/******************************************************************
* @NAME y.xiang
* @CREATEDATE 2020/3/12
* @DESC <实时消息对接>
* ****************************************************************/
import teleport from './utmTeleport.vue'
let that;
let alarmIdList = [];
let alarmInfo = {};
let curAudioInfo = {};
let dom;
export default {
  name: "realTimeMessage",
  components: {teleport},
  data(){
    return{
      openBarrierModal: false,
      openBarrierMessageId: null,
      openBarrierInfo: {
        vehicleId: null,
        accessRecordId: null,
        plateNumber:"",
        accessZoneId: null,
        controlType: 0,
        remarks: ""
      },
      showMessageList:[],
      unregisteredVehicleList:[], //Unregistered Vehicle Detection事件列表
      vehicleShowCount: 10,
      colors:["#dbdbdb", "#dbdbdb", "#f2c355", "#da5050"],
      isAudioLoop:false, // 是否循环播放
      audioSource: process.env.NODE_ENV === "development" ? require("../../../../static/audio/" + window.g.audioFileName) : "/static/audio/" + window.g.audioFileName,
      videoRole: ['M_ViewMyAlarmVideo', 'M_ViewMyNotificationVideo', 'M_ViewMyTaskVideo'], // 视频播放权限
    }
  },
  mounted(){
    that = this;
    console.log('Audio:' + this.audioSource)
    dom = document.getElementById("alarm-audio");
    that.getRealMessage();
    // 监听本地事件处理,当事件被处理或者无需处理的事件已读时被触发
    eventBus.$on('closeMsgAudio',function(ids){
      that.handleAlarmProcessed(ids);
    })
  },
  beforeDestroy(){
    eventBus.$off('realTimeMessageArrived');
    eventBus.$off('closeMsgAudio');
  },
  methods:{
    //获取实时消息
    getRealMessage:function(){
      eventBus.$on('realTimeMessageArrived',function(message){
        that.addRealMessage(message);
        // 播放音频
        if(message.canPlayAudio){
          alarmInfo[ message.id ] = JSON.parse(JSON.stringify(message));
          that.deleteAudioAlarm();
          alarmIdList.push( message.id );
          curAudioInfo = alarmInfo[ message.id ];
          that.playAudio( message );
        }
        // 自动关闭窗口
        that.closeRealMessageByTimer(message);
      });
    },
    //增加实时消息
    addRealMessage:function(message){
      if( message.vehicle && message.vehicle.enabledVehicleTask ){
        that.unregisteredVehicleList.unshift(message);
      }else{
        that.showMessageList.unshift(message);
      }
    },
    // 定时关闭消息窗口
    closeRealMessageByTimer:function(message){
      if( !message.isAutoDisappear || !message.disappearDelayTime ){
        return;
      }
      let duration = Number(message.disappearDelayTime);
      let msgId = message.id;
      let closeTimer = setTimeout(()=>{
        let isVehicleNotice = message.vehicle && message.vehicle.enabledVehicleTask;
        that.closeRealMessage(msgId, isVehicleNotice);
        clearTimeout(closeTimer);
        closeTimer = null;
      }, duration * 1000 );
    },
    //关闭实时消息
    closeRealMessage:function(id, isVehicleNotice){
      if( isVehicleNotice ){
        for( let i=0, len=that.unregisteredVehicleList.length; i<len; i++ ){
          let item = that.unregisteredVehicleList[ i ];
          if( item.messageId === id ){
            that.unregisteredVehicleList.splice(i, 1);
            break;
          }
        }
      }else{
        for( let i=0, len=that.showMessageList.length; i<len; i++ ){
          let item = that.showMessageList[ i ];
          if( item.messageId === id ){
            that.showMessageList.splice(i, 1);
            break;
          }
        }
      }
    },
    // 关闭所有实时消息
    closeAllRealMessage:function(){
      that.showMessageList = [];
    },
    // 关闭所有未注册车辆通知
    closeAllVehicleNotice: function(){
      that.unregisteredVehicleList = [];
    },
    // 关闭未注册车辆消息
    closeUnregVehicleMessage: function(id, index){
      that.unregisteredVehicleList.splice(index, 1);
    },
    // 消息详情
    viewMessageDetail:function (data, isVehicleNotice, needVehicleDeal) {
      console.log(9090,data);
      if( !needVehicleDeal ){
        that.closeRealMessage(data.messageId, isVehicleNotice);
      }
      eventBus.$emit('msgDetail', data, 0, true, 2, false, false, data.category, true,false,false);
    },
    // 播放视频
    playVideo: function(data){
      console.log('videovideovdeio');
      eventBus.$emit('msgDetail', data, 1, false, 0, false, false, data.category, true,false,false);
    },
    getSyncAgora:function(){
      eventBus.$emit('syncAgoraDetails');
    },
    /**
     * 车辆操作
     */
    handleVehicleNoticeScroll: function(e){
      let target = e.target;
      if( target.scrollTop + 0.74 >= target.scrollHeight - target.offsetHeight ){
        if( that.unregisteredVehicleList.length > that.vehicleShowCount ){
          that.vehicleShowCount = that.vehicleShowCount + 10;
        }
      }
    },
    // Open Barrier
    openBarrier: function(item){
      that.openBarrierMessageId = item.messageId;
      that.openBarrierInfo = {
        vehicleId: item.vehicle.vehicleId,
        accessRecordId: item.vehicle.accessRecordId,
        plateNumber:item.vehicle.plateNumber,
        accessZoneId: item.accessZoneId,
        controlType: 0,
        remarks: ""
      }
      that.openBarrierModal = true;
    },
    // Open Barrier
    confirmOpenBarrier: function(){
      that.$ajax.post('DoorAccessControl/RemoteControlBarrierGate', that.openBarrierInfo).then(function (res) {
        if(res.data.success){
          that.messageNotice("success");
          that.openBarrierModal = false;
          that.closeRealMessage(that.openBarrierMessageId, true);
        }else{
          that.messageNotice("error",res.data.message);
        }
      })
    },
    // 注册车辆
    registerVehicle: function(item){
      eventBus.$emit('openVehicleRegistration', item);
      that.closeRealMessage(item.messageId, true);
    },
    /**
     * 播放音频
     */
    // 删除多余的非循环的报警音频
    deleteAudioAlarm:function(){
      if( alarmIdList.length ){
        let index = alarmIdList.length - 1;
        let id = alarmIdList[ index ];
        if( alarmInfo[ id ] ){
          if( alarmInfo[ id ].playAudioType === "0" ){
            alarmIdList.splice( index, 1 );
            delete alarmInfo[ id ];
          }
        }
      }
    },
    // 当前报警音频播放完毕
    handleAudioEnd:function(){
      let curLen = alarmIdList.length;
      let curId = alarmIdList[ curLen - 1 ];
      alarmIdList.splice( curLen-1, 1 );
      delete alarmInfo[ curId ];
      if( alarmIdList.length > 0){
        // 获取上一个循环播放的音频
        curAudioInfo = alarmInfo[ alarmIdList[ alarmIdList.length - 1 ] ];
        if( curAudioInfo ){
          that.playAudio(curAudioInfo);
        }
      }else{
        //console.log("无音频")
        that.stopAudio();
      }
    },
    // 事件被处理之后,关闭相关的音频
    handleAlarmProcessed:function(ids){
      if(!ids || ids.length === 0){
        return;
      }
      let isCurVideoEnd = false;
      // 循环播放列表中删除已处理的id
      ids.forEach((id)=>{
        let index = alarmIdList.indexOf(id);
        if( index > -1 ){
          if( index === alarmIdList.length - 1 ){
            isCurVideoEnd = true;
          }
          delete alarmInfo[ id ];
          alarmIdList.splice(index, 1);
        }
      });
      // 当前音频播放完毕
      if(isCurVideoEnd){
        if( alarmIdList.length > 0 ){
          // 获取上一个循环播放的音频
          curAudioInfo = alarmInfo[ alarmIdList[ alarmIdList.length - 1 ] ];
          if( curAudioInfo ){
            that.playAudio( curAudioInfo );
          }
        }else{
          that.stopAudio();
        }
      }
      ids.forEach((id)=>{
        that.unregisteredVehicleList = that.unregisteredVehicleList.filter((item)=>{
          return item.messageId !== id;
        })
        that.showMessageList = that.showMessageList.filter((item)=>{
          return item.messageId !== id;
        })
      })
    },
    // 停止音频
    stopAudio:function(){
      dom.pause();
      dom.currentTime = 0;
    },
    // 播放音频
    playAudio:function(data){
      that.stopAudio();
      if(data.playAudioType === "1"){
        that.isAudioLoop = true;
      }else{
        that.isAudioLoop = false;
      }
      dom.play();
    },
  },
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/realTimeMessage.js